package com.sweetlime.dungeonamigo.presentation.features.auth

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.sweetlime.dungeonamigo.model.UserProfile
import com.sweetlime.dungeonamigo.repository.AuthRepository
import com.sweetlime.dungeonamigo.repository.UserRepository
import com.sweetlime.dungeonamigo.state.AuthState
import com.sweetlime.dungeonamigo.util.UsernameGenerator
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class AuthViewModel(
    private val repository: AuthRepository,
    private val userRepository: UserRepository,
) : ViewModel() {

    private val _state = MutableStateFlow<AuthState>(AuthState.Idle)
    val state = _state.asStateFlow()

    fun login(email: String, password: String) {
        viewModelScope.launch {
            _state.value = AuthState.Loading
            try {
                repository.login(email, password)
                val uid = repository.currentUserId()!!
                if (userRepository.getUserProfile(uid) == null) {
                    userRepository.createUserProfile(
                        UserProfile(id = uid, username = UsernameGenerator.generate(), email = email)
                    )
                }
                _state.value = AuthState.Success(uid)
            } catch (e: Exception) {
                _state.value = AuthState.Error(e.message ?: "Login failed")
            }
        }
    }

    fun signup(email: String, password: String) {
        viewModelScope.launch {
            _state.value = AuthState.Loading
            try {
                repository.signup(email, password)
                val uid = repository.currentUserId()!!
                try {
                    userRepository.createUserProfile(
                        UserProfile(id = uid, username = UsernameGenerator.generate(), email = email)
                    )
                } catch (profileError: Exception) {
                    runCatching { repository.deleteAccount() }
                    throw Exception("Account setup failed. Please try again.")
                }
                _state.value = AuthState.Success(uid)
            } catch (e: Exception) {
                _state.value = AuthState.Error(e.message ?: "Signup failed")
            }
        }
    }

    fun logout() {
        viewModelScope.launch {
            try {
                repository.logout()
                _state.value = AuthState.Idle
            } catch (e: Exception) {
                _state.value = AuthState.Error(e.message ?: "Logout failed")
            }
        }
    }
}
